/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, shape, bool, string, number,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Edit from '@material-ui/icons/Edit';
import configENV from '../../../../config';
import { getUpdatedUserEmail } from '../../../../state/ducks/Common/Common-Selectors';

const { PERSIST_KEY } = configENV;
const styles = (theme) => ({
    blockContent: {
        padding: '10px 10px',
        minHeight: 150,
        lineHeight: 1.5,
    },
    blockMessage: {
        padding: '20px 0px',
    },
    labelName: {
        color: theme.palette.grey[600],
    },
    blockMessageFaded: {
        padding: '20px 0px',
        color: theme.palette.grey[600],
        fontSize: 12,
    },
    blockActions: {
        textAlign: 'right',
        padding: '0px 5px',
        color: theme.palette.grey[600],
        verticalAlign: 'super',
    },
});

class DesktopAccountUserProfile extends React.PureComponent {
    handleGotoURL = (url) => {
        const { history: { push } } = this.props;
        push(url);
    };

    render() {
        const { classes, userProfile, email } = this.props;
        return (
            <>
                <div className={classes.blockContent}>
                    <div className={classes.blockMessage}>
                        <div>
                            <span className={classes.labelName}>Name:  </span>
                            <span className="bold"> {userProfile.firstName}{' '}{userProfile.lastName} </span>
                        </div>
                        <div>
                            <span className={classes.labelName}>Email:  </span>
                            <span className="bold">{email}</span>
                        </div>
                    </div>
                    <div className={`gray-color small ${classes.blockMessageFaded}`}>
                        Click Edit to update your password.

                    </div>
                    <div className="blue-color align-right">
                        <span className="link-button" role="presentation" onClick={() => this.handleGotoURL('/account/profile')}>
                            <Edit style={{ verticalAlign: 'middle' }} className="link-icon" />
                            <span className="link-label">Edit</span>
                        </span>
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        toggleState: newState.toggleState,
        email: getUpdatedUserEmail(state),
    };
};

DesktopAccountUserProfile.defaultProps = {
    email: '',
};

DesktopAccountUserProfile.propTypes = {
    classes: object.isRequired,
    history: object.isRequired,
    userProfile: shape({
        accessToken: string.isRequired,
        idToken: string.isRequired,
        ContactId: string.isRequired,
        userType: string.isRequired,
        userRole: string,
        email: string.isRequired,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string.isRequired,
        lastName: string.isRequired,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    email: string,
};
export default connect(mapStateToProps, null)(withRouter(withStyles(styles)(DesktopAccountUserProfile)));
